module.exports = __webpack_public_path__ + "images/category_lp/earphone/point3_6cc2203e13a5795d2385add844ced79c.png";